export default "__VITE_ASSET__BKtmGnb4__"